import {useSyncExternalStore} from 'react';
import LiveConnectionNotice from '../components/live-connection-notice';
import {getPublicSalesEventsConnectionState, hasActivePublicSalesEvents, observePublicSalesEventConnection, recoverPublicSalesEvents} from './public-sales-events';

const serverState = () => 'live';

export default function WebsiteConnectionNotice() {
    const state = useSyncExternalStore(observePublicSalesEventConnection, getPublicSalesEventsConnectionState, serverState);
    const active = useSyncExternalStore(observePublicSalesEventConnection, hasActivePublicSalesEvents, () => false);
    return <LiveConnectionNotice state={state} active={active} onReconnect={recoverPublicSalesEvents} />;
}
